export function renderAbout() {
    return `
      <article>
        <div class="about-section">
          <div class="about-content">
            <p>I'm the co-founder & CEO of <a href="https://nessielabs.com" target="_blank">Nessie</a>, a YC-backed startup building the infrastructure for recursive companies: companies that get better with every piece of work their people and agents do.</p>
            <p>Previously, I engineered large-scale recommendation systems on Amazon's core Personalization team.</p>
            <p>I studied Computer Science at Yale, where I explored how narrative, identity, and technology shape how we think and who we become.</p>
            <p>I believe in building things that help people think and write their own stories - especially when life is messy.</p>
          </div>
        </div>
        <div class="beliefs-section">
          <h3>Some Things I Believe</h3>
          <ul class="beliefs-list">
            <li><strong>Follow the obsession.</strong> The best things get built by people who can't stop thinking about the problem, not people who picked the most rational one.</li>
            <li><strong>Surf the uncertainty.</strong> The breakthroughs don't come from resolving ambiguity - they come from learning to stay in it.</li>
            <li><strong>You are what you do.</strong> Identity is forged through action, not the other way around. You don't "be" and then "do."</li>
            <li><strong>The best moat is an opinion.</strong> Great products are philosophy embedded in software.</li>
            <li><strong>Stay embodied.</strong> A mind that outruns the body loses authority over itself. Build things that keep people grounded, not things that erase how they think.</li>
            <li><strong>Kill your darlings.</strong> The real problem is never the first one you see. Keep moving from symptom to root cause, even when it means throwing away what you built.</li>
            <li><strong>Don't take yourself too seriously.</strong> At the end of the day, it's all a beautiful, absurd, infinite game. Laughter is the final form of freedom.</li>
          </ul>
        </div>

        <div class="social-links">
          <a href="https://github.com/annayzhang1337" target="_blank" class="social-link">GitHub</a>
          <a href="https://www.linkedin.com/in/anna-zhang-y/" target="_blank" class="social-link">LinkedIn</a>
          <a href="https://x.com/anna_y_zhang" target="_blank" class="social-link">X</a>
          <a href="https://annayutongzhang.substack.com" target="_blank" class="social-link">Substack</a>
          <a href="https://medium.com/@anna-y-zhang" target="_blank" class="social-link">Medium</a>
        </div>
      </article>
    `
}
